var render = function render(){var _vm=this,_c=_vm._self._c;return _c('guest-order-details-dialog',{attrs:{"order":_vm.order,"changing-status-order-id":_vm.changingStatusOrderId},on:{"change-status":_vm.changeStatus},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }